import { HttpClient } from '@angular/common/http';
import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import {
  Constants,
  LocalStoragerService,
  SessionStoragerService,
} from '../_utility';
import { Languages, LoggedUser, Role, Roles } from '../_models';
import { jwtDecode } from 'jwt-decode';
import { environment } from '../../environments/environment';
import { SpinnerService } from '../_components/spinner/spinner.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  public userData: any;

  constructor(
    public router: Router,
    private http: HttpClient,
    private spinner: SpinnerService,
    public lStorager: LocalStoragerService,
    private sStorage: SessionStoragerService,
    public ngZone: NgZone // NgZone service to remove outside scope warning
  ) {}

  // Ritorna true quando utente è loggato e l'email è verifcato
  get isLoggedIn(): boolean {
    return !!this.user && !!this.token ? true : false;
  }

  // Ritorna il token o stringa vuota
  get token(): string {
    return this.user && this.user.idToken ? this.user.idToken : '';
  }

  // Ritorna se il token è scaduto
  get isExpiredToken(): boolean {
    if (this.token) {
      let tokenDecoded: any = jwtDecode(this.token);
      let expMillis = tokenDecoded.exp * 1000;
      let nowMillis = new Date().getTime();
      return nowMillis > expMillis;
    }

    return true;
  }

  // Returns user when is looged or null
  get user(): LoggedUser | null {
    return this.lStorager.getElement(Constants.Storager.CURRENT_USER);
  }

  set user(user: LoggedUser | null) {
    if (user) {
      this.lStorager.setElement(Constants.Storager.CURRENT_USER, user);
    } else {
      this.lStorager.removeElement(Constants.Storager.CURRENT_USER);
    }
  }

  // Ritorna le Roles dell'utente
  get roles(): Roles[] {
    let tmp: LoggedUser | null = this.user;
    return tmp ? tmp.user_roles : [];
  }

  get uuidPassenger(): string | null {
    let currentUser: LoggedUser | null = this.user;
    return currentUser && currentUser.uuidPassenger
      ? currentUser.uuidPassenger
      : null;
  }

  // Ritorna la lingua selezionata
  get lang(): string {
    let retrieved_lang = this.sStorage.getElement(Constants.Storager.LANG);
    return retrieved_lang ? retrieved_lang : Languages.default;
  }

  set lang(lang: string | null) {
    if (lang) {
      this.sStorage.setElement(Constants.Storager.LANG, lang);
    } else {
      this.sStorage.removeElement(Constants.Storager.LANG);
    }
  }

  get displayName(): string | null {
    let currentUser: LoggedUser | null = this.user;
    return currentUser ? currentUser.displayName : null;
  }

  get inizialiNome(): string | null {
    let temp = this.displayName!.split(' ');
    temp.map((n) => n[0]).join('');
    let name = [];
    name.push(temp[0].substring(0, 1));
    name.push(temp[temp.length - 1].substring(0, 1));
    return name.join('');
  }

  SignIn(body: any) {
    let url = `${environment.host}${environment.api}/login`;
    return this.http.post<any>(url, body);
  }

  SignOut() {
    this.lStorager.clearAll();
    this.sStorage.clearAll();
    this.router.navigate(Constants.Routing.LANDING.routerLink);
  }

  isEmployeeWithoutPassenger(): boolean {
    let roles: Roles[] = this.roles;
    return (
      roles &&
      (roles.includes(Roles.ADMIN) || roles.includes(Roles.OPERATORE)) &&
      !this.uuidPassenger
    );
  }

  public setUserInfo(
    res: any,
    localStorage: boolean = true
  ): LoggedUser | null {
    let user: LoggedUser = new LoggedUser();
    let tokenDecoded: any = jwtDecode(res.idToken);
    let roles = tokenDecoded.role;
    let str_roles: any[] | string = [];
    user.displayName = res.displayName ? res.displayName : null;
    user.email = res.email ? res.email : null;
    user.idToken = res.idToken ? res.idToken : null;
    user.uuidPassenger = res.uuidPassenger ? res.uuidPassenger : null;

    if (roles) {
      str_roles = roles;

      if (typeof str_roles === 'string') {
        let tmp: string = str_roles;
        str_roles = [tmp];
      }

      str_roles.forEach((role) => {
        let new_role = Role.get_Role(role);
        if (new_role) roles.push(new_role);
      });

      if (roles) {
        user.user_roles = roles;
      }
    }

    if (user.idToken && user.displayName && user.user_roles) {
      return (this.user = user);
    }

    return null;
  }
}
